import { YoutubeEmbed } from './YoutubeEmbed'

interface VideoPlayerProps {
  youtubeId?: string
  videoUrl?: string
  title: string
  className?: string
}

/** Renders a self-hosted <video> when videoUrl is set, otherwise falls back to YouTube embed. */
export function VideoPlayer({ youtubeId, videoUrl, title, className }: VideoPlayerProps) {
  const wrapper = `relative w-full overflow-hidden rounded-lg bg-black pt-[56.25%] ${className ?? ''}`

  if (videoUrl) {
    return (
      <div className={wrapper}>
        <video
          className="absolute inset-0 h-full w-full"
          src={videoUrl}
          title={title}
          controls
          playsInline
        />
      </div>
    )
  }

  if (youtubeId) {
    return <YoutubeEmbed youtubeId={youtubeId} title={title} className={className} />
  }

  return null
}
